module.exports = __webpack_public_path__ + "media/images/xc_2-97c0fb989cde37ac9e3f363cde9af522.png";